import React from "react";
import { Box, Heading, Text, Link } from "@chakra-ui/react";
import Card from "./Card";
import DownloadApp from "./DownloadApp";

const blogCards = [
  // 4 from BlogSection
  {
    title: "Best Online Loan Options in Canada for 2026",
    description: <Link href="/blog/best-online-loan-options-canada-2026" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/money_transfer.png"),
    ref:"/blog/best-online-loan-options-canada-2026",
  },
  {
    title: "10 Factors That Affect Your Loan Approval",
    description: <Link href="/blog/factors-that-affect-loan-approval" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/currency_map.png"),
    ref:"/blog/factors-that-affect-loan-approval",
  },
  {
    title: "How to Spot and Avoid Loan Scams",
    description: <Link href="/blog/how-to-spot-and-avoid-loan-scams" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/currency_exchange.png"),
    ref:"/blog/how-to-spot-and-avoid-loan-scams",
  },
  {
    title: "How to Borrow Smartly Through the Year",
    description: <Link href="/blog/how-to-borrow-smartly-through-the-year" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/destination.png"),
    ref:"/blog/how-to-borrow-smartly-through-the-year",
  },
  // 8 additional cards
  {
    title: "Top 7 Credit-Building Habits for 2026",
    description: <Link href="/blog/top-7-credit-building-habits-2026" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/top_relocate_countries_2026.png"),
    ref:"/blog/top-7-credit-building-habits-2026",
  },
 {
    title: "Understanding APR, Interest, and Total Loan Cost",
   description: <Link href="/blog/understanding-apr-interest-and-total-loan-cost" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/exchange_rate.png"),
    ref:"/blog/understanding-apr-interest-and-total-loan-cost",
  },
   {
    title: "Credit and Loan Guide for Newcomers in Canada",
    description: <Link href="/blog/credit-and-loan-guide-for-newcomers-canada-2026" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/canada_immigration.png"),
    ref:"/blog/credit-and-loan-guide-for-newcomers-canada-2026"
  },
  {
    title: "How to Avoid Hidden Fees in Loans",
    description: <Link href="/blog/how-to-avoid-hidden-fees-in-loans" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/hidden_fees.png"),
    ref:"/blog/how-to-avoid-hidden-fees-in-loans",
  },
  
  {
    title: "Safe Online Borrowing: Security Checklist",
    description: <Link href="/blog/safe-online-borrowing-security-checklist" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/safe_transfer.png"),
    ref:"/blog/safe-online-borrowing-security-checklist",
  },

  
  /*{
    title: "Digital Wallets vs. Traditional Banking",
    description: <Link href="#" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/digital_wallet.png"),
  },
  
  {
    title: "The Rise of Fintech in Africa",
    description: <Link href="#" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/fintech_africa.png"),
  },
  {
    title: "What to Know before choosing a cross-border transfer app",
    description: <Link href="#" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/remittance_laws.png"),
  },*/
];

export default function Blog() {
  return (
    <Box maxW="1500px" mx="auto" px={{ base: 4, md: 8 }} py={{ base: 24, md: 40 }}>
      <Heading as="h1" size="2xl" mb={2} mt={2} textAlign="center">
        Swift Credit Blog
      </Heading>
      <Box mb={16} textAlign="center">
        <span style={{ fontSize: '1.2rem', color: '#4A5568' }}>
          Insights, tips, and practical guides on credit, borrowing, repayment, and responsible lending.
        </span>
      </Box>
      <Box
        display="grid"
        gridTemplateColumns={{ base: "1fr", md: "repeat(2,minmax(0,1fr))", lg: "repeat(4,minmax(0,1fr))" }}
        gridGap={{ base: 6, md: 8 }}
        maxWidth="1500px"
        margin="0 auto"
      >
        {blogCards.map((project) => (
          <Card
            key={project.title}
            title={project.title}
            description={project.description}
            imageSrc={project.getImageSrc()}
            imageBorder="2px solid #d3d3d3"
            imageHref={project.ref}
          />
        ))}
      </Box>
        
           
    </Box>
  );
}
